<div class="dashboard-container">
  <!-- Left Side - Enquiry List -->
  <div class="left-side">
    <app-enquiry-list></app-enquiry-list>
  </div>

  <!-- Right Side - Route Content -->
  <div class="right-side">
    <router-outlet></router-outlet>
  </div>
</div> 